import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Cookies from 'js-cookie';

import Dashboard from './app/Pages/Dashboard';
import Founders from './app/Pages/Founders';
import Angels from './app/Pages/Angels';
import VCs from './app/Pages/VCs';
import Accelerators from './app/Pages/Accelerators';
import Reports from './app/Pages/Reports';
import Transaction from './app/Pages/Transactions';
import Setting from './app/Pages/Settings';
import Login from './app/Pages/Login/Login';
import NoResults from './app/components/Noresults'
import VerifyEmail from './app/Pages/Login/verifyEmail';

import './App.css';
import { useStaticDataStore } from './app/stores/staticData';

function App() {
  const rememberMe = Cookies.get('rememberMe') === 'true';

  const fetchOnce = useStaticDataStore((s) => s.fetchOnce);

  useEffect(() => {
    fetchOnce();
  }, [fetchOnce]);

  return (
    <BrowserRouter>
      <Routes>
        {rememberMe ? (
          <>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard/" element={<Dashboard />} />
            <Route path="/founders/*" element={<Founders />} />
            <Route path="/angels/*" element={<Angels />} />
            <Route path="/vcs/*" element={<VCs />} />
            <Route path="/accelerators/*" element={<Accelerators />} />
            <Route path="/reports/*" element={<Reports />} />
            <Route path="/transactions/*" element={<Transaction />} />
            <Route path="/setting/*" element={<Setting />} />
            <Route
              path="*"
              element={
                <NoResults
                  title="No result found"
                  description="We couldn't find anything matching your search. Try adjusting your filters or check back later for new updates!"
                  fromHome="true"
                />
              }
            />
          </>
        ) : (
          <>
            <Route path="*" element={<Navigate to="/sign-in" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sign-in" element={<Login />} />
            <Route path="/verify" element={<VerifyEmail />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
